<template>
    <EventsListSliceDefault v-if="slice.variation === 'default'" :slice="slice" />
    <EventsListSliceSelection v-else :slice="slice" />
</template>

<script setup lang="ts">
    import {getSliceComponentProps} from '@prismicio/vue';
    import type {EventsListSlice} from '@prismicio-types';
    import EventsListSliceDefault from './EventsListDefault.vue';
    import EventsListSliceSelection from './EventsListSelection.vue';
    defineProps(getSliceComponentProps<EventsListSlice>());
</script>
